// eslint-disable-next-nine @typescript-eslint/no-use-before-define
import React from 'react'
import { Box, Flex } from '@chakra-ui/core'
import styled from '@emotion/styled'
import { DEVICE_TYPES } from 'constants/UI'
import useWindowDimensions from 'hooks/useWindowDimensions'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import PageTitle from 'components/PageTitle'
import { PageConfigProvider } from 'contexts'
import Sidebar from 'components/Sidebar'
import TaskOverviewSidebar from 'components/Sidebar/TaskOverviewSidebar'
import TaskSidebar from 'components/Sidebar/TaskSidebar'
import { ReportSideBar } from '../Sidebar/ReportSidebar'
import { AgentSidebar } from 'components/Agent/components/AgentSidebar'
import { AgentProvider } from 'contexts'
import { useDynamicContentHeight } from 'components/Setup/SetupModal/hooks/useDynamicHeight'
import { PPTourProvider } from 'components/ProductPerformance/tour/PPTourContext'

const Content = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const PageContent = styled(Box)`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`

const MainLayout = ({ children, sidebarComponent, ...props }: any) => {
  const { windowWidth } = useWindowDimensions()
  const dynamicContentHeight = useDynamicContentHeight()
  return (
    <>
      <Flex className="main-layout" m="auto" position="relative" h={dynamicContentHeight}>
        {DEVICE_TYPES.DESKTOP(windowWidth) && <>{sidebarComponent}</>}
        <Content
          as="main"
          width={{
            lg: '75%',
            base: '100%',
          }}
          bg="#f7f7f7"
          {...props}
        >
          {children}
        </Content>
      </Flex>
    </>
  )
}

const Layout = ({ children }: { children: JSX.Element }) => (
  <PageConfigProvider>
    <MainLayout sidebarComponent={children}>
      <PageTitle />
      <PageContent>
        <Outlet />
      </PageContent>
    </MainLayout>
  </PageConfigProvider>
)
export const LayoutWithoutSidebar = () => (
  <PageConfigProvider>
    <MainLayout>
      <PageTitle />
      <PageContent>
        <Outlet />
      </PageContent>
    </MainLayout>
  </PageConfigProvider>
)

export const LayoutWithMainSidebar = () => (
  <PPTourProvider>
    <Layout>
      <Sidebar />
    </Layout>
  </PPTourProvider>
)

export const LayoutWithTaskOverviewSidebar = () => (
  <Layout>
    <TaskOverviewSidebar />
  </Layout>
)

export const LayoutWithTasksSidebar = () => (
  <Layout>
    <TaskSidebar />
  </Layout>
)
type Props = {
  isShowTitle?: boolean
}

export const LayoutWithTitleSideBar = ({ isShowTitle }: Props) => (
  <Layout>
    <ReportSideBar isShowTitle={isShowTitle} />
  </Layout>
)

export const LayoutWithAgentSidebar = () => {
  const activeGroupId = useSelector((state: RootState) => state.config.activeGroupID)
  return (
    <AgentProvider activeGroupId={activeGroupId}>
      <MainLayout sidebarComponent={<AgentSidebar />} minW={0}>
        <PageContent overflow="hidden">
          <Outlet />
        </PageContent>
      </MainLayout>
    </AgentProvider>
  )
}
